import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import isInternal from 'utils/isInternal'
import getRelativeUrl from 'utils/getRelativeUrl'

class FlexibleLink extends Component {
  static propTypes = {
    href: PropTypes.string,
    children: PropTypes.node
  }

  render() {
    const { href, children, target, ...rest } = this.props

    const internal = href && target !== '_blank' && isInternal(href)

    if (internal) {
      return <Link to={getRelativeUrl(href)} {...rest}>{children}</Link>
    }

    return (
      <a
        href={href}
        target={target || '_blank'}
        {...rest}
      >
        {children}
      </a>
    )
  }
}

export default FlexibleLink



// WEBPACK FOOTER //
// ./src/ui/components/generic/FlexibleLink.js